import { ReducerInitialStates } from '../../contexts/ford-rides-context/ford-rides-context';

export const SHIFT_DATA = 'SHIFT_DATA';
export interface RidesReducerAction {
    type: 'SHIFT_DATA';
    payload: ReducerInitialStates;
}

const fordRidesReducer = (
    state: ReducerInitialStates,
    action: RidesReducerAction
) => {
    if (action.type === SHIFT_DATA) {
        return {
            ...state,
            ...action.payload,
        };
    } else {
        return state;
    }
};

export default fordRidesReducer;
